import * as types from './actionTypes';

export const fetchFixedDeduction = (payload) => ({  
  type: types.PAYROLL_DEDUCTION_FETCH_FIXED_DEDUCTION,
  payload,
});

export const fetchFixedDeductionSuccess = (data) => ({
  type: types.PAYROLL_DEDUCTION_FETCH_FIXED_DEDUCTION_SUCCESS,
  payload: data,
});

export const fetchFixedDeductionFailure = (error) => ({
  type: types.PAYROLL_DEDUCTION_FETCH_FIXED_DEDUCTION_FAILURE,
  payload: error,
});

export const saveFixedDeduction = (payload) => ({
  type: types.PAYROLL_DEDUCTION_SAVE_FIXED_DEDUCTION,
  payload,
});

export const removeFixedDeduction = (payload) => ({
  type: types.PAYROLL_DEDUCTION_REMOVE_FIXED_DEDUCTION,
  payload,
});

export const removeFixedDeductionSuccess = (data) => ({
  type: types.PAYROLL_DEDUCTION_REMOVE_FIXED_DEDUCTION_SUCCESS,
  payload: data,
});

export const removeFixedDeductionFailure = (error) => ({
  type: types.PAYROLL_DEDUCTION_REMOVE_FIXED_DEDUCTION_FAILURE,
  payload: error,
});

export const changeFixedDeductionStatus = (payload) => ({
  type: types.PAYROLL_DEDUCTION_CHANGE_FIXED_DEDUCTION_STATUS,
  payload,
});

export const fetchDeduction = (unit_id,type_id) => ({
  type: types.PAYROLL_DEDUCTION_FETCH_DROPDOWN_DEDUCTION,
  payload:{unit_id,type_id}
});

export const fetchDeductionSuccess = (data) => ({
  type: types.PAYROLL_DEDUCTION_FETCH_DROPDOWN_DEDUCTION_SUCCESS,
  payload: data,
});

export const fetchDeductionFailure = (error) => ({
  type: types.PAYROLL_DEDUCTION_FETCH_DROPDOWN_DEDUCTION_FAILURE,
  payload: error,
});

export const getMonthlyDeductionTemplate = (payload) => ({
  type: types.PAYROLL_DEDUCTION_FIXED_TEMPLATE,
  payload,
});

export const deductionlistImport = (payload) => ({
  type: types.PAYROLL_DEDUCTION_FIXED_IMPORT,
  payload,
});